import {
	getRawMaterial,
	getYingyangMess,
	addCailiao,
	getCailiaoList,
	getYuancailiaoTree,
	getcaipinTree,
	delYuancailiaoTree,
	getCailiaoTypes,
	updateYuancailiaoTree,
	addYuancailiaoTree,
	delCailiaoByid,
	putCailiaoByid,
	addZaolei,
	getZaoleiList,
	editZaoleiByid,
	delZaoleiByid,
	delBiaoqianByid,
	editBiaoqianByid,
	getBiaoqianList,
	addBiaoqian,
	addKouwei,
	getKouweiList,
	editKouweiByid,
	delKouweiByid,
	addType,
	getTypeList,
	editTypeByid,
	delTypeByid,
	getDishList,
	plAddcaipin,
	delDish,
	getTaocan,
	getCaipuList,
	fabuCaipu,
	editCaipu,
	editCaipuDetail,
	delCaipuDetail,
	delCaipin,
	delCaiyuan,
	addProduct,
	getProductList,
	editProduct,
	delProduct,
	getauditMenudish,
	getauditOne,
	addAudit,
	addAuditPicture,
	getMaterialBaseLibrary,
	pushCaipu,
	saveDianzanDish,
	getDianzanDish,
	getDianzanPaihang,
	clearDianzanPaihang,
	getAudit,
	getdishesfenlei,
	pushdishesfenlei,
	editdishesfenlei,
	delDishesfenlei,
	getdishesgongxiao,
	pushdishesgongxiao,
	editdishesgongxiao,
	delDishesgongxiao,
	getdishescaixi,
	pushdishescaixi,
	editdishescaixi,
	delDishescaixi,
	getdishessyrq,
	pushdishessyrq,
	editdishessyrq,
	delDishessyrq,
	getDishList2,
	addNutrimententer,
	delNutrimententer,
	getNutrimententerlist,
	editNutrimententer,
	getSamplerecord,
	getSamplerecordcanteen,
	addConsultation,
	getConsultation,
	updateConsultation,
	delConsultation,
	delChronicId,
	changeProductState,
	getMenuaicanteen,
	getMenuaidishespicture,
	plEditdishespicture,
	plDeldishespicture,
	getDishesnum,
	importInitmenudishes,
	getConsultationDetail,
	getDish,
	getDishDetail,
	addDish2,
	editDish2,
	addMenurecipe,
	delMenurecipe,
	delMenurecipeDetail,
	getMenurecipeByday,
	getDishTree,
	getYingyang,
	xiafaRecipe,
	getRecipeNew,
	xiafaRecipeNew,
	fabuCaipuList
} from '@/api/menudish'
// import { getToken } from '@/utils/auth'
const state = {}
const mutations = {}

const actions = {
	fabuCaipuList ({}, data) {
		return new Promise((resolve, reject) => {
			fabuCaipuList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getRecipeNew ({}, data) {
		return new Promise((resolve, reject) => {
			getRecipeNew(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	xiafaRecipe ({}, data) {
		return new Promise((resolve, reject) => {
			xiafaRecipe(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getYingyang ({}, data) {
		return new Promise((resolve, reject) => {
			getYingyang(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDishTree ({}, data) {
		return new Promise((resolve, reject) => {
			getDishTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMenurecipeByday ({}, data) {
		return new Promise((resolve, reject) => {
			getMenurecipeByday(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delMenurecipe ({}, data) {
		return new Promise((resolve, reject) => {
			delMenurecipe(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delMenurecipeDetail ({}, data) {
		return new Promise((resolve, reject) => {
			delMenurecipeDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addMenurecipe ({}, data) {
		return new Promise((resolve, reject) => {
			addMenurecipe(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addDish2 ({}, data) {
		return new Promise((resolve, reject) => {
			addDish2(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editDish2 ({}, data) {
		return new Promise((resolve, reject) => {
			editDish2(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDish ({}, data) {
		return new Promise((resolve, reject) => {
			getDish(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDishDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getDishDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	changeProductState ({}, data) {
		return new Promise((resolve, reject) => {
			changeProductState(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	clearDianzanPaihang ({}, data) {
		return new Promise((resolve, reject) => {
			clearDianzanPaihang(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDianzanPaihang ({}, data) {
		return new Promise((resolve, reject) => {
			getDianzanPaihang(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDianzanDish ({}, data) {
		return new Promise((resolve, reject) => {
			getDianzanDish(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveDianzanDish ({}, data) {
		return new Promise((resolve, reject) => {
			saveDianzanDish(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addProduct ({}, data) {
		return new Promise((resolve, reject) => {
			addProduct(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getProductList ({}, data) {
		return new Promise((resolve, reject) => {
			getProductList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editProduct ({}, data) {
		return new Promise((resolve, reject) => {
			editProduct(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delProduct ({}, data) {
		return new Promise((resolve, reject) => {
			delProduct(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	fabuCaipu ({}, data) {
		return new Promise((resolve, reject) => {
			fabuCaipu(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCaipuList ({}, data) {
		return new Promise((resolve, reject) => {
			getCaipuList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editCaipu ({}, data) {
		return new Promise((resolve, reject) => {
			editCaipu(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editCaipuDetail ({}, data) {
		return new Promise((resolve, reject) => {
			editCaipuDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCaiyuan ({}, data) {
		return new Promise((resolve, reject) => {
			delCaiyuan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCaipin ({}, data) {
		return new Promise((resolve, reject) => {
			delCaipin(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCaipuDetail ({}, data) {
		return new Promise((resolve, reject) => {
			delCaipuDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getTaocan ({}, data) {
		return new Promise((resolve, reject) => {
			getTaocan(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDish ({}, data) {
		return new Promise((resolve, reject) => {
			delDish(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plAddcaipin ({}, data) {
		return new Promise((resolve, reject) => {
			plAddcaipin(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDishList ({}, data) {
		return new Promise((resolve, reject) => {
			getDishList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDishList2 ({}, data) {
		return new Promise((resolve, reject) => {
			getDishList2(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getYingyangMess ({}, data) {
		return new Promise((resolve, reject) => {
			getYingyangMess(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addCailiao ({}, data) {
		return new Promise((resolve, reject) => {
			addCailiao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delCailiaoByid ({}, data) {
		return new Promise((resolve, reject) => {
			delCailiaoByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addYuancailiaoTree ({}, data) {
		return new Promise((resolve, reject) => {
			addYuancailiaoTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateYuancailiaoTree ({}, data) {
		return new Promise((resolve, reject) => {
			updateYuancailiaoTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delYuancailiaoTree ({}, data) {
		return new Promise((resolve, reject) => {
			delYuancailiaoTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getYuancailiaoTree ({}, data) {
		return new Promise((resolve, reject) => {
			getYuancailiaoTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getcaipinTree ({}, data) {
		return new Promise((resolve, reject) => {
			getcaipinTree(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCailiaoTypes ({}, data) {
		return new Promise((resolve, reject) => {
			getCailiaoTypes(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getCailiaoList ({}, data) {
		return new Promise((resolve, reject) => {
			getCailiaoList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	putCailiaoByid ({}, data) {
		return new Promise((resolve, reject) => {
			putCailiaoByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addZaolei ({}, data) {
		return new Promise((resolve, reject) => {
			addZaolei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getZaoleiList ({}, data) {
		return new Promise((resolve, reject) => {
			getZaoleiList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editZaoleiByid ({}, data) {
		return new Promise((resolve, reject) => {
			editZaoleiByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delZaoleiByid ({}, data) {
		return new Promise((resolve, reject) => {
			delZaoleiByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addBiaoqian ({}, data) {
		return new Promise((resolve, reject) => {
			addBiaoqian(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getBiaoqianList ({}, data) {
		return new Promise((resolve, reject) => {
			getBiaoqianList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editBiaoqianByid ({}, data) {
		return new Promise((resolve, reject) => {
			editBiaoqianByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delBiaoqianByid ({}, data) {
		return new Promise((resolve, reject) => {
			delBiaoqianByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addKouwei ({}, data) {
		return new Promise((resolve, reject) => {
			addKouwei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getKouweiList ({}, data) {
		return new Promise((resolve, reject) => {
			getKouweiList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editKouweiByid ({}, data) {
		return new Promise((resolve, reject) => {
			editKouweiByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delKouweiByid ({}, data) {
		return new Promise((resolve, reject) => {
			delKouweiByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addType ({}, data) {
		return new Promise((resolve, reject) => {
			addType(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getTypeList ({}, data) {
		return new Promise((resolve, reject) => {
			getTypeList(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editTypeByid ({}, data) {
		return new Promise((resolve, reject) => {
			editTypeByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delTypeByid ({}, data) {
		return new Promise((resolve, reject) => {
			delTypeByid(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getauditMenudish ({}, data) {
		return new Promise((resolve, reject) => {
			getauditMenudish(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getauditOne ({}, data) {
		return new Promise((resolve, reject) => {
			getauditOne(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addAudit ({}, data) {
		return new Promise((resolve, reject) => {
			addAudit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addAuditPicture ({}, data) {
		return new Promise((resolve, reject) => {
			addAuditPicture(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMaterialBaseLibrary ({}, data) {
		return new Promise((resolve, reject) => {
			getMaterialBaseLibrary(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pushCaipu ({}, data) {
		return new Promise((resolve, reject) => {
			pushCaipu(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getAudit ({}, data) {
		return new Promise((resolve, reject) => {
			getAudit(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getdishesfenlei ({}, data) {
		return new Promise((resolve, reject) => {
			getdishesfenlei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pushdishesfenlei ({}, data) {
		return new Promise((resolve, reject) => {
			pushdishesfenlei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editdishesfenlei ({}, data) {
		return new Promise((resolve, reject) => {
			editdishesfenlei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDishesfenlei ({}, data) {
		return new Promise((resolve, reject) => {
			delDishesfenlei(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getdishesgongxiao ({}, data) {
		return new Promise((resolve, reject) => {
			getdishesgongxiao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pushdishesgongxiao ({}, data) {
		return new Promise((resolve, reject) => {
			pushdishesgongxiao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editdishesgongxiao ({}, data) {
		return new Promise((resolve, reject) => {
			editdishesgongxiao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDishesgongxiao ({}, data) {
		return new Promise((resolve, reject) => {
			delDishesgongxiao(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getdishescaixi ({}, data) {
		return new Promise((resolve, reject) => {
			getdishescaixi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editdishescaixi ({}, data) {
		return new Promise((resolve, reject) => {
			editdishescaixi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDishescaixi ({}, data) {
		return new Promise((resolve, reject) => {
			delDishescaixi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getdishessyrq ({}, data) {
		return new Promise((resolve, reject) => {
			getdishessyrq(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pushdishessyrq ({}, data) {
		return new Promise((resolve, reject) => {
			pushdishessyrq(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editdishessyrq ({}, data) {
		return new Promise((resolve, reject) => {
			editdishessyrq(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delDishessyrq ({}, data) {
		return new Promise((resolve, reject) => {
			delDishessyrq(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	pushdishescaixi ({}, data) {
		return new Promise((resolve, reject) => {
			pushdishescaixi(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addNutrimententer ({}, data) {
		return new Promise((resolve, reject) => {
			addNutrimententer(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delNutrimententer ({}, data) {
		return new Promise((resolve, reject) => {
			delNutrimententer(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getNutrimententerlist ({}, data) {
		return new Promise((resolve, reject) => {
			getNutrimententerlist(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	editNutrimententer ({}, data) {
		return new Promise((resolve, reject) => {
			editNutrimententer(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getSamplerecord ({}, data) {
		return new Promise((resolve, reject) => {
			getSamplerecord(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	addConsultation ({}, data) {
		return new Promise((resolve, reject) => {
			addConsultation(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getSamplerecordcanteen ({}, data) {
		return new Promise((resolve, reject) => {
			getSamplerecordcanteen(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getConsultation ({}, data) {
		return new Promise((resolve, reject) => {
			getConsultation(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	updateConsultation ({}, data) {
		return new Promise((resolve, reject) => {
			updateConsultation(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delConsultation ({}, data) {
		return new Promise((resolve, reject) => {
			delConsultation(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	delChronicId ({}, data) {
		return new Promise((resolve, reject) => {
			delChronicId(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMenuaicanteen ({}, data) {
		return new Promise((resolve, reject) => {
			getMenuaicanteen(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getMenuaidishespicture ({}, data) {
		return new Promise((resolve, reject) => {
			getMenuaidishespicture(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plEditdishespicture ({}, data) {
		return new Promise((resolve, reject) => {
			plEditdishespicture(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	plDeldishespicture ({}, data) {
		return new Promise((resolve, reject) => {
			plDeldishespicture(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getDishesnum ({}, data) {
		return new Promise((resolve, reject) => {
			getDishesnum(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	importInitmenudishes ({}, data) {
		return new Promise((resolve, reject) => {
			importInitmenudishes(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getRawMaterial ({}, data) {
		return new Promise((resolve, reject) => {
			getRawMaterial(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	getConsultationDetail ({}, data) {
		return new Promise((resolve, reject) => {
			getConsultationDetail(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	xiafaRecipeNew ({}, data) {
		return new Promise((resolve, reject) => {
			xiafaRecipeNew(data)
				.then(res => {
					resolve(res)
				})
				.catch(error => {
					reject(error)
				})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
